<template>
<div>
<img :src="flagIcon" alt="国旗icon" class="flag"/>    
  <el-dropdown trigger="click" class='international' @command="handleSetLanguage">
    <div>
      <span class="el-dropdown-link langs">{{language}}<i class="el-icon-arrow-down el-icon--right"></i>
    </span>
    </div>
    <el-dropdown-menu slot="dropdown">
      <el-dropdown-item command="zh_cn">简体中文</el-dropdown-item>
      <el-dropdown-item command="en_us">English</el-dropdown-item>
      <el-dropdown-item command="km_kh">មែរ</el-dropdown-item>
    </el-dropdown-menu>
  </el-dropdown>
  </div>
</template>
<script>
export default {
  data() {
    return {
      language: ""
      // flagIcon:require("../assets/China.png")
    };
  },
  mounted() {
    const _lang = localStorage.lang || "zh_cn";
    this.getLanguage(_lang);
  },
  computed: {
    flagIcon() {
      if (this.$i18n.locale == "zh_cn") {
        return require("../assets/China.png");
      } else if (this.$i18n.locale == "en_us") {
        return require("../assets/USA.png");
      } else if (this.$i18n.locale == "km_kh") {
        return require("../assets/Cambodia.png");
      }
    }
  },
  methods: {
    handleSetLanguage(lang) {
      this.$i18n.locale = lang;
      localStorage.setItem("lang", lang);
      this.getLanguage(lang);
      this.$emit("handIt");
    },
    getLanguage(val) {
      if (val === "zh_cn") {
        this.language = "简体中文";
      }
      if (val === "en_us") {
        this.language = "English";
      }
      if (val === "km_kh") {
        this.language = "មែរ";
      }
    }
  }
};
</script>
<style>
.flag {
  width: 40px;
  vertical-align: middle;
  margin-right: 4px;
}
.international{
}
.langs {
  color: #fff;
}

</style>

